// the default locale
// you can for example take it from the URL.
let locale = 'cs';

// the translation data
// you can load/fetch these from files or keep them hardcoded.
let messages = {
  cs: {
    add_anotther_attenedd: 'Přidat dalšího účastníka',
    register: 'Přidat účastníka',
    sale_activated: 'Skupinová sleva aktivována',
    sale_participant:
      'Pro získání skupinové slevy je potřeba přidat ještě jednoho účastníka',
    sale_participants:
      'Pro získání skupinové slevy je potřeba přidat alespoň {count} účastníky',
    general_error:
      'Z technických problémů nebylo možné registraci dokončit. Náš tým byl o tomto problému informován. Zkuste se prosím registrovat později a nebo nás kontaktujte e-mailem na info@blueevents.eu.',
    new: 'Nezpracována',
    processed: 'Rozpracována',
    completed: 'Hotovo',
    true: 'Ano',
    false: 'Ne',
    showMore: 'Načíst další články',
    loading: 'Načítání',
    sent: 'Odesláno',
    short: 'Příliš krátké',
    empty: 'Je požadovaná hodnota',
    number: 'Musí být číslo',
    format: 'Musí být ve správném formátu',
  },
  en: {
    add_anotther_attenedd: 'Add participant',
    register: 'Register',
    sale_activated: 'Group discount is activated',
    sale_participant:
      'Add one more participant to get the volume package discount.',
    sale_participants:
      'Add {count} more participants to get the volume package discount.',
    general_error:
      'Registration could not be completed due to technical problems. Our team has been notified of this issue. Please try to register later or contact us by email at info@blueevents.eu.',
    new: 'New',
    processed: 'Processed',
    completed: 'Completed',
    true: 'Yes',
    false: 'No',
    showMore: 'Show more',
    loading: 'Loading',
    sent: 'Sent',
    short: 'Too short',
    empty: 'Value is required',
    number: 'Must be number',
    format: 'Incorrect format',
  },
};

// finally, pass them to AlpineI18n:
document.addEventListener('alpine-i18n:ready', function () {
  window.AlpineI18n.create(locale, messages);
});
